<div class="reklamieren-page" [class.reklamieren-page--dialog]="dialog">
    <kiene-page-header *ngIf="!dialog" [ueberschrift]="ueberschrift"></kiene-page-header>

    <div class="reklamieren-body">
        <div *ngIf="isLoading" class="reklamieren-loading">
            <span>Lade Tier...</span>
        </div>

        <div *ngIf="!isLoading" class="reklamieren-content">
            <h3 style="margin-block-end: 12px; margin-block-start: 0">Ohrmarke {{ this.tier?.ohrmarke_notnull }}</h3>

            <mat-hint style="text-align: justify; display: inline-block; font-size: 0.8em">
                <strong>Hinweis:</strong> Neue Bemerkungen können über das + Symbol hinzugefügt werden.
            </mat-hint>

            <div class="reklamieren-header-row" [style.margin-top]="dialog ? '8px' : '0'">
                <strong class="kiene-primary">Bemerkungen Schnellauswahl</strong>
                <button
                    data-cy="bemerkung-add"
                    color="accent"
                    mat-icon-button
                    (click)="openCreateDialog()"
                    [disabled]="isSaving"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <div class="reklamieren-list-wrapper">
                <div class="reklamieren-empty" *ngIf="optionen.length === 0">
                    <mat-hint style="font-size: 0.8em">Noch keine Bemerkungen angelegt</mat-hint>
                </div>

                <div *ngIf="optionen.length > 0" class="reklamieren-list-scroll" data-cy="bemerkung-zuletzt">
                    <div
                        (click)="toggleOption({ checked: !option.checked }, option, $event)"
                        *ngFor="let option of optionen; let index = index"
                        class="reklamieren-list-row"
                    >
                        <mat-checkbox
                            id="bemerkung-option-{{ index }}"
                            [checked]="option.checked"
                            (change)="toggleOption($event, option)"
                            data-cy="bemerkung-zuletzt-eintrag"
                        >
                            {{ option.text }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <div
                [style]="
                    dialog
                        ? 'position: sticky; bottom: 0; background-color: white; padding: 12px 0 0 0;'
                        : 'padding-top: 16px'
                "
                class="one-row"
                [class.reklamieren-actions-dialog]="dialog"
                [style.justify-content]="dialog ? 'space-between' : 'center'"
            >
                <button
                    class="reklamieren-save-button"
                    color="accent"
                    mat-flat-button
                    data-cy="bemerkung-save"
                    (click)="save()"
                    [disabled]="isSaving"
                >
                    Bemerkung speichern
                </button>
                <span *ngIf="dialog" class="spacer"></span>
                <ng-content select="[additional-actions]"></ng-content>
            </div>
        </div>
    </div>
</div>
